module.exports = __webpack_public_path__ + "static/media/upload.ae4bae99.svg";